import type { AfterResponseState } from 'ky';

/**
 * Logs the details of an HTTP response to the console in a collapsed group.
 *
 * This function is intended to be used as a Ky `afterResponse` hook.
 * It clones the response to safely read its body as text, then logs the
 * response URL, body, headers, and status code in a structured format.
 *
 * @param {AfterResponseState} param0 - The state object containing the request, response, and options.
 * @returns {Promise<Response | undefined>} The original response, wrapped in a Promise.
 */
export const logResponse = async ({
  options: _,
  request,
  response,
}: AfterResponseState): Promise<Response | undefined> => {
  const body = await response.clone().text();

  console.groupCollapsed(`Response: ${request.url}`);
  console.dir({
    body,
    headers: Object.fromEntries(response.headers.entries()),
    status: response.status,
  });
  console.groupEnd();

  return response;
};
